import { useEffect } from "@wordpress/element";
import ImageGrid from "./components/ImageGrid";
import ProvidersAndFilters from "./components/ProvidersAndFilters";

const App = () => {

	return ( 
		<div key={"image-hub-app-container"} className="image-hub-app-container">
			<ProvidersAndFilters  media={true} />
			<ImageGrid media={true} />
		</div>
	);
};

export default App;
